import React from 'react';
import { ShiftProviderUser } from 'models';
import { Row, Avatar, Text, Link } from 'library/ui';
import { Colors } from 'library';

export function BusinessSlotHeader({ provider, headline }: { provider?: ShiftProviderUser; headline: string }) {
    const name = provider ? `${provider.first_name} ${provider.last_name}` : '';
    return provider ? (
        <Row gap="sm" align="center">
            <Avatar imageUrl={provider.profile_picture?.image} name={name} size={28} color={Colors.primary} />
            <Link to={`/provider/${provider.id}`} weight="semibold">
                {name}
            </Link>
        </Row>
    ) : (
        <Text weight="bold">{headline}</Text>
    );
}
